
// Require the lazyload before requiring any other modules.
import './common/lazyload';

window.Popper = require('popper.js').default;
window.$ = window.jQuery = require('jquery');
//expose jquery for external use
window.jQueryExternal = jQuery;
window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

import './sigmagi/vendor/bootstrap';
import './common/jquery.extendedContains';
import 'slick-slider';

import Router from './util/Router';
import globalRoute from './common/routes/common';
import commonRoute from './sigmagi/routes/common';
import homepageRoute from './sigmagi/routes/homepage';
import productsRoute from './sigmagi/routes/products';
import dashboardRoute from './sigmagi/routes/dashboard';
import checkoutRoute from './sigmagi/routes/checkout';
import productRoute from './sigmagi/routes/product';
import registerRoute from './sigmagi/routes/register';

/** Populate Router instance with DOM routes */
const routes = new Router({
  globalRoute, // All pages, all domains
  commonRoute, // All pages
  homepageRoute,
  productsRoute,
  dashboardRoute,
  checkoutRoute,
  productRoute,
  registerRoute
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());
